/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 모바일의 메인 렌더링 컴포넌트입니다.
 * 이 컴포넌트에서 모바일에서 렌더되는 모든 항목의 렌더링을 제어할 수 있습니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { Switch, Route, HashRouter } from 'react-router-dom';
import Footer from 'common-modules/general/Common/Components/Footer/Mobile';
import Header from 'common-modules/general/Common/Components/Header/Mobile';
import CompanyInfo from './Sales/Company';
import SalesHeader from './Sales/SalesHeader';
import Main from 'pages/mobile/Sales/Contents/GeneralOutline/index';
import Info from 'pages/mobile/Sales/Contents/Info/index';
import Location from 'pages/mobile/Sales/Contents/Location/index';
import Exhbt from 'pages/mobile/Sales/Contents/Exhbt/index';
import News from 'pages/mobile/Sales/Contents/News/index';
import NewsDetail from 'pages/mobile/Sales/Contents/News/Detail';
import Household from 'pages/mobile/Sales/Contents/Household/index';
import Event from 'pages/mobile/Sales/Contents/Event/index';
import EventDetailPage from 'pages/mobile/Sales/Contents/Event/OpenPage';
import Street from 'pages/mobile/Sales/Contents/Street/index';
import { RoutesString } from 'common-modules/general/Config/routesString';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import NoticeBurgerMenu from 'common-modules/general/Common/Components/BurgerMenu/NoticeBurgerMenu';
import TopBannerComponent from 'common-modules/general/Common/Components/TopBannerContainer';
import styled from 'styled-components';
import { useState } from 'react';
import BurgerMenuWrap from 'common-modules/general/Common/Components/Header/Mobile/BurgerMenu';
import { slide as Menu } from 'react-burger-menu';
import './common.scss';

const Contents = styled.div`
  position: relative;
`;

interface Props {
  mainModel: MainModel;
}

const Mobile = ({ mainModel }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Menu
        onClose={() => setIsOpen(false)}
        burgerButtonClassName={'mobile-burger-button'}
        isOpen={isOpen}
        right
        width={'calc(100vw - 60px)'}>
        <BurgerMenuWrap setIsOpen={setIsOpen} />
      </Menu>

      {/* 브랜드, 분양, 마이홈, 로그인 등이 있는 헤더입니다. */}
      <NoticeBurgerMenu direction="bottom" mainModel={mainModel} />

      {/* 콘텐츠 표출 태그 */}
      <Contents>
        {/* 탑배너 데이터가 있을 경우 탑배너를 표출합니다. */}
        <TopBannerComponent mainModel={mainModel} isMobile />
        {/* 기본 헤더(GNB) 입니다. */}
        <Header isBanner setIsOpen={setIsOpen} isOpen={isOpen} />

        {/* 큰 백그라운드 이미지와 관심고객 등록 SNS공유 기능이 있는 분양페이지의 헤더입니다. */}
        <SalesHeader mainModel={mainModel} />

        <HashRouter>
          {/* 아래는 소메뉴들의 페이지들입니다. 각 탭을 클릭시 지정한 메뉴의 컴포넌트가 렌더링됩니다. */}
          <Switch>
            <Switch>
              <Route path={RoutesString.Main} exact render={props => <Main mainModel={mainModel} />} />
              <Route path={RoutesString.SalesOverView} exact render={props => <Main mainModel={mainModel} />} />
              <Route path={RoutesString.SalesInfo} exact render={props => <Info mainModel={mainModel} />} />
              <Route path={RoutesString.SalesExhbt} exact render={props => <Exhbt />} />
              <Route path={RoutesString.SalesHousehold} render={props => <Household />} />
              <Route path={RoutesString.SalesLocation} exact render={props => <Location />} />
              <Route path={RoutesString.SalesStreet} exact render={props => <Street />} />
              <Route path={RoutesString.SalesNews} exact render={props => <News />} />
              <Route path={RoutesString.SalesNews} render={props => <NewsDetail />} />
              <Route path={RoutesString.SalesEvent} exact render={props => <Event />} />
              <Route path={RoutesString.SalesEventDetail} render={props => <EventDetailPage />} />
            </Switch>
          </Switch>
        </HashRouter>

        {/* 시행사 정보입니다. */}
        <CompanyInfo />

        {/* Footer 입니다. */}
        <Footer />
      </Contents>
    </>
  );
};

export default Mobile;
